import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation UnmuteUser($muteeId: String!) {
    unmuteUser(muteeId: $muteeId) {
      success
      message
    }
  }
`

export interface UnmuteUserInput {
  muteeId: string
}

export interface UnmuteUserOutput {
  unmuteUser: {
    success: boolean
    message: string
  }
}

export const useUnmuteUser = () => useMutation<UnmuteUserOutput, UnmuteUserInput>(mutation)
